<template>
  <div class="modal">
    <v-dialog :value="value" @input="$emit('input')" transition="fade-transition" fullscreen>
      <div>
        <v-card>
          <v-toolbar color="elevation-2">
            <v-toolbar-title class="headline">Audience Data</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text v-if="influencer == null || !influencer.success">
            <v-row>
              <v-col cols="12">
                  <h2 class="text-center" style="color: rgba(0,0,0,.38);">Empty data</h2>
                  <v-btn color="info" class="white--text ml-0" @click="refreshReport">
                    Refresh
                    <v-icon float-right dark>refresh</v-icon>
                  </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text v-if="influencer !=null && influencer.success">
            <v-row>
              <v-col cols="12" xs="12" md="12">
                <div class="card">
                  <div class="card-body">
                    <div v-if="influencer && influencer.success">
                      <h5>Created: {{influencer ? reportCreatedAt : ''}}</h5>
                      <h5>Version: {{influencer ? influencer.version : ''}}</h5>
                    </div>
                    <v-btn color="blue-grey" class="white--text ml-0" @click="downloadPdf">
                      Download
                      <v-icon float-right dark>save_alt</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xs="12" md="12">
                <div class="card">
                  <div class="card-body">
                    <center class="m-t-30">
                      <img v-bind:src="paserImageUrl(influencerProfile.picture)" class="img-circle" width="150" />
                      <h2 class="card-title m-t-10">{{influencerProfile.fullname}}</h2>
                      <a v-bind:href="influencerProfile.url" target="_blank">
                        <h3>@{{influencerProfile.username}}</h3>
                      </a>
                      <h4
                        class="card-subtitle"
                        v-if="influencerProfile.is_business"
                      >Business Account</h4>
                      <h6
                        class="card-subtitle"
                        v-if="!influencerProfile.is_business"
                      >Personal Account</h6>
                      <!-- <div class="row text-center justify-content-md-center">
                        <div class="col-4"><a href="javascript:void(0)" class="link"><i class="icon-people"></i> <font class="font-medium">254</font></a></div>
                        <div class="col-4"><a href="javascript:void(0)" class="link"><i class="icon-picture"></i> <font class="font-medium">54</font></a></div>
                      </div>-->
                    </center>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col xs="12" md="4">
                <div class="card border p-1">
                  <div class="card-body text-center">
                    <p class="card-title" style="font-size: 16px">Followers</p>
                    <span class="card-title" style="font-size: 30px">
                      <b>{{influencerProfile.followers}}</b>
                      <span
                        v-if="followingStat"
                        _ngcontent-c16
                        v-bind:class="'text stat-label ng-star-inserted ' + 'stat-label--' + followingStat.type"
                      >
                        <span _ngcontent-c16>{{followingStat.rate}}%</span>
                        <!---->
                      </span>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4">
                <div class="card border p-1">
                  <div class="card-body text-center">
                    <p class="card-title mb-0" style="font-size: 16px">Location</p>
                    <h2
                      class="card-title mt-0"
                    >{{audienceFollowers.audience_geo.countries ? (audienceFollowers.audience_geo.countries.length ? audienceFollowers.audience_geo.countries[0].name : '---') : '---'}}</h2>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4">
                <div class="card border p-1">
                  <div class="card-body text-center">
                    <h2 class="card-title">
                      {{influencerProfile.engagements}}
                      <small>engagements</small>
                    </h2>
                  </div>
                </div>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col xs="12" md="6">
                <div class="card">
                  <div class="card-body text-center">
                    <h2 class="card-title">
                      {{influencerProfile.avg_likes}}
                      <small>Avg Likes</small>
                    </h2>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="6">
                <div class="card">
                  <div class="card-body text-center">
                    <h2 class="card-title">
                      {{influencerProfile.avg_comments}}
                      <small>Avg Comments</small>
                    </h2>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col xs="12" md="4">
                <div class="card">
                  <div class="card-body text-center">
                    <line-chart :chart-data="datacollection" />
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4">
                <div class="card">
                  <div class="card-body text-center">
                    <line-chart :chart-data="avgLikes" />
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4">
                <div class="card">
                  <div class="card-body text-center">
                    <line-chart :chart-data="followingData" />
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col xs="12" md="6" v-if="wordCloud && wordCloud.length > 0">
                <div class="card">
                  <div class="card-body text-center" style="height: 350px">
                    <h4 class="card-title">Social Cloud</h4>
                    <vue-word-cloud
                      style="position: relative"
                      :v-show="true"
                      :words="wordCloud"
                      :color="([,]) => getRandomColor()"
                      font-family="Roboto"
                    />
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="6">
                <v-row>
                  <div class="card">
                    <div class="card-body text-center">
                      <h4 class="card-title">Popular @</h4>
                      <v-chip
                        color="#eff4fa"
                        v-for="mention in influencerProfile.top_mentions.slice(0, 10)"
                        :key="mention.tag"
                        text-color="#4a4a4a"
                      >@{{mention.tag}}</v-chip>
                      <!-- <span v-for="mention in influencerProfile.top_mentions" class="badge badge-pill badge-info">@{{mention.tag}}</span> -->
                    </div>
                  </div>
                </v-row>
                <v-row>
                  <div class="card">
                    <div class="card-body text-center">
                      <h4 class="card-title">Popular #</h4>
                      <v-chip
                        v-for="hashtag in influencerProfile.top_hashtags.slice(0, 10)"
                        :key="hashtag.tag"
                        color="#eff4fa"
                        text-color="#4a4a4a"
                      >#{{hashtag.tag}}</v-chip>
                    </div>
                  </div>
                </v-row>
              </v-col>
            </v-row>
            <!-- Audience data -->
            <v-row v-if="influencer.audience_followers.success">
              <v-col>
                <h3 class="text-center">Audience Data</h3>
              </v-col>
            </v-row>
            <!-- Followers Credibility -->
            <v-row v-if="influencer.audience_followers.success">
              <v-col xs="12" md="6">
                <v-row>
                  <v-col>
                    <div class="card">
                      <div class="card-body text-center">
                        <h4 class="card-title">Followers Credibility</h4>
                        <h3>
                          <v-icon
                            large
                            :color="getCredibilityColor(audienceFollowers.audience_credibility)"
                          >supervised_user_circle</v-icon>
                        </h3>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <!-- Notable Followers -->
                <v-row>
                  <v-col>
                    <div class="card">
                      <div class="card-body text-center">
                        <h4 class="card-title">Notable Followers</h4>
                        <h3>{{toPercent(audienceFollowers.notable_users_ratio)}}%</h3>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- <v-row v-if="audienceFollowers.audience_genders.length > 0"> -->
                <v-row>
                  <v-col xs="12" md="6">
                    <div class="card">
                      <div class="card-body text-center">
                        <h4 class="card-title">Age Split</h4>
                        <bar-chart
                          :options="barChartOptions"
                          :chart-data="audienceFollowersGenderPerAge"
                        />
                      </div>
                    </div>
                  </v-col>
                  <v-col xs="12" md="6">
                    <div class="card">
                      <div class="card-body text-center">
                        <h4 class="card-title">Gender Split</h4>
                        <circle-chart :chart-data="audienceFollowersGender" />
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col xs="12" md="6">
                <div class="card">
                  <div class="card-body text-center">
                    <div>
                      <!-- <bar-chart :options="barChartOptions" :chart-data="audienceReachabilityData" /> -->
                      <bar-chart-js
                        name="audBarChart"
                        :chartData="audienceReachabilityData"
                        :options="audChartOptions"
                      />
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="influencer.audience_followers.success">
              <v-col xs="12" md="4" v-if="audienceFollowers.audience_geo && audienceFollowers.audience_geo.countries.length > 0">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title text-center">Location by Country</h4>
                    <div
                      v-for="country of audienceFollowers.audience_geo.countries.slice(0, 3)"
                      :key="country.code"
                    >
                      <h5 style="font-weight:600;">
                        {{country.name}}
                        <span
                          style="float:right"
                        >{{(country.weight * 100).toFixed(2)}}%</span>
                      </h5>
                      <b-progress
                        :value="country.weight * 100"
                        :max="100"
                        :precision="2"
                        class="mb-4"
                      ></b-progress>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4" v-if="audienceFollowers.audience_ethnicities.length > 0">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title text-center">Ethnicity</h4>
                    <div
                      v-for="item of audienceFollowers.audience_ethnicities.slice(0, 5)"
                      :key="item.code"
                    >
                      <h5>
                        {{item.name}}
                        <span style="float:right">{{(item.weight * 100).toFixed(2)}}%</span>
                      </h5>
                      <b-progress
                        show-progress
                        animated
                        :value="item.weight * 100"
                        :max="100"
                        :precision="2"
                        class="mb-4"
                      ></b-progress>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4" v-if="audienceFollowers.audience_languages.length > 0">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title text-center">Language</h4>
                    <div
                      v-for="item of audienceFollowers.audience_languages.slice(0, 5)"
                      :key="item.code"
                    >
                      <h5>
                        {{item.name}}
                        <span style="float:right">{{(item.weight * 100).toFixed(2)}}%</span>
                      </h5>
                      <b-progress :value="item.weight * 100" :max="100" :precision="2" class="mb-4"></b-progress>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="influencer.audience_followers.success">
              <v-col xs="12" md="4" v-if="audienceFollowers.audience_brand_affinity.length > 0">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title text-center">Audience Brand Affinity</h4>
                    <div
                      v-for="item of audienceFollowers.audience_brand_affinity.slice(0, 5)"
                      :key="item.name"
                    >
                      <h5>
                        {{item.name}}
                        <span style="float:right">{{(item.weight * 100).toFixed(2)}}%</span>
                      </h5>
                      <b-progress :value="item.weight * 100" :max="100" :precision="2" class="mb-4"></b-progress>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4" v-if="audienceFollowers.audience_interests.length > 0">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title text-center">Audience Interests</h4>
                    <div
                      v-for="item of audienceFollowers.audience_interests.slice(0, 5)"
                      :key="item.name"
                    >
                      <h5>
                        {{item.name}}
                        <span style="float:right">{{(item.weight * 100).toFixed(2)}}%</span>
                      </h5>
                      <b-progress
                        show-progress
                        animated
                        :value="item.weight * 100"
                        :max="100"
                        :precision="2"
                        class="mb-4"
                      ></b-progress>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4" v-if="audienceFollowers.notable_users.length > 0">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title text-center">Notable Followers</h4>
                    <ul class="products-list product-list-in-box">
                      <li
                        class="item"
                        v-for="item of audienceFollowers.notable_users.slice(0, 4)"
                        :key="item.username"
                      >
                        <div class="product-img">
                          <img v-bind:src="paserImageUrl(item.picture)" alt="Avatar" />
                        </div>
                        <div class="product-info">
                          <a
                            v-bind:href="item.url"
                            target="_blank"
                            class="product-title"
                          >@{{item.username}}</a>
                          <span class="product-description">{{item.fullname}}</span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4" v-if="audienceFollowers.audience_geo && audienceFollowers.audience_geo.countries.length > 0">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title text-center">Location by Country</h4>
                    <div>
                      <v-simple-table class="aud-location-table no-border">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Country</th>
                              <th class="text-right">Followers</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                            v-for="country of audienceFollowers.audience_geo.countries"
                            :key="country.code">
                              <td class="text-left pl-0">
                                <h5 style="font-weight:600;">
                                  {{country.name}}
                                </h5>
                              </td>
                              <td class="text-right">
                                <span
                                  style="float:right"
                                >{{(country.weight * 100).toFixed(2)}}%</span>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col xs="12" md="4" v-if="audienceFollowers.audience_interests && audienceFollowers.audience_interests.length > 0">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title text-center">Audience Interest Affinity</h4>
                    <div>
                      <v-simple-table class="aud-location-table no-border">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left">Interest</th>
                              <th class="text-right">Followers</th>
                              <th class="text-right">Followers affinity</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                            v-for="brand of audienceFollowers.audience_interests.slice(0, 15)"
                            :key="brand.code">
                              <td class="text-left pl-0">
                                <h5 style="font-weight:600;">
                                  {{brand.name}}
                                </h5>
                              </td>
                              <td class="text-right">
                                <span
                                  style="float:right"
                                >{{(brand.weight * 100).toFixed(2)}}%</span>
                              </td>
                              <td class="text-right">
                                <span
                                  style="float:right"
                                >{{(brand.affinity * 100).toFixed(2)}}%</span>
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

        <!-- Footer -->
        <div class="modal-footer">
          <v-btn @click="close">Close</v-btn>
        </div>
        </v-card>
      </div>
    </v-dialog>
    <!-- <loading
      :active.sync="showLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="180"
      height.number="180"
    /> -->
  </div>
</template>

<script>
import VueWordCloud from 'vuewordcloud';
import LineChart from '../../charts/LineChart.js';
import BarChart from '../../charts/BarChart.js';
import BarChartJs from '@/components/chartjs/Bar';
import CircleChart from '../../charts/CircleChart.js';
import moment from 'moment';
import influencerAPIs from './influencerAPIs';
import Loading from 'vue-loading-overlay';

export default {
  name: 'AudienceDataReportModal',
  props: {
    value: Boolean,
    audienceData: Object,
    handle: String,
    platform: String
  },
  components: { [VueWordCloud.name]: VueWordCloud, LineChart, BarChart, CircleChart, BarChartJs, Loading },
  data() {
    return {
      userGender_options: {},
      // user info
      influencer: null,
      influencerProfile: null,
      // Audience data
      audienceFollowers: null,
      audienceLikes: null,
      reportInfo: null,
      datacollection: null,
      wordCloud: null,
      barChartOptions: {
        barPercentage: 0.1,
        maxBarThickness: 'flex',
        categoryPercentage: 0.5
      },
      audChartOptions: {
        responsive: true,
        interaction: {
          intersect: false
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true
          }
        }
      },
      audienceReachabilityData: null,
      audienceFollowersGenderPerAge: null,
      audienceFollowersAge: null,
      audienceFollowersGender: null,
      avgLikes: null,
      followingData: null,
      chartOptions: {},
      words: [],
      emojiPath: '/static/img/emoji/',
      showLoading: false
    };
  },
  watch: {
    audienceData: function(newInfluencerData) {
      this.formatAudience(newInfluencerData);
      this.resetChart();
      this.influencer = newInfluencerData;
    },
    influencer: function(newData) {
      if (newData.success) {
        this.createChartDataFollowers();
        this.createChartDataEngagements();
        this.createChartDataFollowing();
        this.createChartDataAudienceReachability();
        this.createChartDataAudienceGendersPerAge();
        this.createChartDataAudienceGenders();
        this.createWordCloud();
      }
    }
  },
  mounted() {
    // Retrieve gender config
    this.influencer = {};
    this.resetChart();
  },

  computed: {
    reportCreatedAt() {
      if (this.influencer && this.influencer.report_info) {
        return moment(this.influencer.report_info.created).format('DD-MM-YYYY HH:MM');
      }
      return '';
    },
    followingStat() {
      if (this.influencerProfile && this.influencerProfile.stat_history.length > 0) {
        let followers = this.influencerProfile.followers;
        let followersLastmonth = this.influencerProfile.stat_history[this.influencerProfile.stat_history.length - 2].followers;
        let rate = (followers - followersLastmonth) / followersLastmonth;
        rate = (rate * 100).toFixed(2);
        let type = 'asc';
        if (rate < 0) {
          rate *= -1;
          type = 'desc';
        }
        return {
          rate,
          type
        };
      }
      return null;
    }
  },
  methods: {
    close() {
      this.value = false
      this.$emit('input');
    },
    refreshReport() {
      if (!this.influencer.success) {
        this.getReportByHandlePlatform(this.handle, this.platform)
      } else {
        let reportId = this.influencer.report_info.report_id;
        influencerAPIs.refreshAudienceReport(reportId).then(data => {
          console.log(data);
        });
      }
    },
    paserImageUrl(url) {
      if (!url) return ''
      var newUrl = url
        .replace('http://imgp.socapi.icu/', location.origin + '/socapi')
        .replace('https://imgp.socapi.icu/', location.origin + '/socapi');
      return newUrl;
    },
    async downloadPdf() {
      let reportId = this.reportInfo.report_id;
      let username = this.influencerProfile.username;
      if (!reportId) {
        return this.$swal({
          title: 'Opp!!!',
          text: 'The report does not exist',
          type: 'info'
        });
      }
      this.$emit('showLoadingEvent', true)
      await influencerAPIs.downloadAudienceReport(reportId, username);
      this.$emit('showLoadingEvent', false)
    },
    formatAudience(data) {
      if (data && data.success) {
        this.influencerProfile = data.user_profile || {};
        this.influencerProfile.top_mentions = this.influencerProfile.top_mentions || [];
        this.influencerProfile.top_hashtags = this.influencerProfile.top_hashtags || [];
        this.influencerProfile.brand_affinity = this.influencerProfile.brand_affinity || [];
        this.influencerProfile.stat_history = this.influencerProfile.stat_history || [];
        this.influencerProfile.relevant_tags = this.influencerProfile.relevant_tags || [];
        this.influencerProfile.similar_users = this.influencerProfile.similar_users || [];
        this.influencerProfile.commercial_posts = this.influencerProfile.commercial_posts || [];
        this.audienceFollowers = data.audience_followers.success ? data.audience_followers.data : {};
        this.audienceLikes = data.audience_likers.success ? data.audience_likers.data : {};
        this.reportInfo = data.report_info || {};
        // Prevent undefined data
        this.audienceFollowers.credibility_class = this.audienceFollowers.credibility_class || 'normal';
        this.audienceFollowers.audience_genders = this.audienceFollowers.audience_genders || [];
        this.audienceFollowers.audience_ages = this.audienceFollowers.audience_ages || [];
        this.audienceFollowers.audience_genders_per_age = this.audienceFollowers.audience_genders_per_age || [];
        this.audienceFollowers.audience_ethnicities = this.audienceFollowers.audience_ethnicities || [];
        this.audienceFollowers.audience_brand_affinity = this.audienceFollowers.audience_brand_affinity || [];
        this.audienceFollowers.audience_interests = this.audienceFollowers.audience_interests || [];
        this.audienceFollowers.audience_lookalikes = this.audienceFollowers.audience_lookalikes || [];
        this.audienceFollowers.audience_geo = this.audienceFollowers.audience_geo || {};
        // this.audienceFollowers.audience_geo.countries = this.audienceFollowers.audience_geo.countries || [];
        this.audienceFollowers.audience_languages = this.audienceFollowers.audience_languages || [];
      } else {
        this.influencerProfile = {};
        this.audienceFollowers = {};
        this.audienceLikes = {};
        this.reportInfo = {};
      }
    },
    createChartDataFollowers() {
      let stats = this.influencerProfile.stat_history;
      let followers = {
        label: 'Followers',
        borderColor: '#42a5f5',
        fill: true,
        data: []
      };
      for (let stat of stats) {
        followers.data.push(stat.followers);
        this.datacollection.labels.push(moment(stat.month).format('Y-MMM'));
      }
      this.datacollection.datasets.push(followers);
    },
    createChartDataEngagements() {
      let stats = this.influencerProfile.stat_history;
      let likes = {
        label: 'Likes',
        borderColor: '#42a5f5',
        fill: true,
        data: []
      };
      for (let stat of stats) {
        likes.data.push(stat.avg_likes);
        this.avgLikes.labels.push(moment(stat.month).format('Y-MMM'));
      }
      this.avgLikes.datasets.push(likes);
    },
    createChartDataFollowing() {
      let stats = this.influencerProfile.stat_history;
      let following = {
        label: 'Following',
        borderColor: '#42a5f5',
        fill: true,
        data: []
      };
      for (let stat of stats) {
        following.data.push(stat.following);
        this.followingData.labels.push(moment(stat.month).format('Y-MMM'));
      }
      this.followingData.datasets.push(following);
    },
    createChartDataAudienceGenders() {
      let geners = this.audienceFollowers.audience_genders;
      let genderData = {
        backgroundColor: ['#42a5f5', '#ff595e'],
        fill: false,
        data: []
      };
      // male
      let maleGender = geners.find(g => g.code === 'MALE')
      if (maleGender) {
        this.audienceFollowersGender.labels.push(maleGender.code)
        genderData.data.push((maleGender.weight * 100).toFixed(2));
      }
      // female
      let femaleGender = geners.find(g => g.code === 'FEMALE')
      if (femaleGender) {
        this.audienceFollowersGender.labels.push(femaleGender.code)
        genderData.data.push((femaleGender.weight * 100).toFixed(2));
      }
      this.audienceFollowersGender.datasets.push(genderData);
    },
    createChartDataAudienceGendersPerAge() {
      let audienceGendersPerAge = this.audienceFollowers.audience_genders_per_age;
      let audienceGendersPerAgeMale = {
        label: 'Male',
        backgroundColor: '#42a5f5',
        data: []
      };
      let audienceGendersPerAgeFemale = {
        label: 'Female',
        backgroundColor: '#ff595e',
        data: []
      };
      for (let data of audienceGendersPerAge) {
        audienceGendersPerAgeMale.data.push((data.male * 100).toFixed(2));
        this.audienceFollowersGenderPerAge.labels.push(data.code);
      }
      for (let data of audienceGendersPerAge) {
        audienceGendersPerAgeFemale.data.push((data.female * 100).toFixed(2));
      }
      this.audienceFollowersGenderPerAge.datasets.push(audienceGendersPerAgeMale);
      this.audienceFollowersGenderPerAge.datasets.push(audienceGendersPerAgeFemale);
    },
    createChartDataAudienceReachability() {
      let audienceReachabilities = this.audienceFollowers.audience_reachability;
      let audienceReachability = {
        label: 'Audience Reachability',
        backgroundColor: '#3F3FFF',
        borderColor: 'black',
        data: []
      };
      for (let reacher of audienceReachabilities) {
        audienceReachability.data.push((reacher.weight * 100).toFixed(2));
        if (reacher.code.startsWith('-')) {
          reacher.code = reacher.code.replace('-', '<')
        } else if (reacher.code.endsWith('-')) {
          reacher.code = reacher.code.replace('-', '>')
        }
        this.audienceReachabilityData.labels.push(reacher.code + ' Followings');
      }
      this.audienceReachabilityData.datasets.push(audienceReachability);
    },
    createWordCloud() {
      let relevantTags = this.influencerProfile.relevant_tags || [];
      this.wordCloud = [];
      for (let relevant of relevantTags) {
        let freq = Number(relevant.freq).toFixed(2);
        this.wordCloud.push([relevant.tag, Number(freq) * 10]);
      }
    },
    resetChart() {
      this.datacollection = {
        labels: [],
        datasets: []
      };
      this.avgLikes = {
        labels: [],
        datasets: []
      };
      this.followingData = {
        labels: [],
        datasets: []
      };
      this.audienceReachabilityData = {
        labels: [],
        datasets: []
      };
      this.audienceFollowersGender = {
        labels: [],
        datasets: []
      };
      this.audienceFollowersGenderPerAge = {
        labels: [],
        datasets: []
      };
    },
    getRandomColor: function() {
      // var letters = '0123456789ABCDEF';
      // var color = '#';
      // for (var i = 0; i < 6; i++) {
      //   color += letters[Math.floor(Math.random() * 16)];
      // }
      // return color;
      return '#947ded'
    },
    getRandomRotation: function(min, max) {
      return Math.random() * (max - min) + min;
    },
    toPercent(num) {
      return (num * 100).toFixed(2);
    },
    getCredibilityColor: function(credibility) {
      let rate = this.toPercent(credibility);
      if (rate >= 0 && rate <= 29) {
        return '#f44336';
      } else if (rate >= 30 && rate <= 59) {
        return '#f9a825';
      } else if (rate >= 60 && rate <= 100) {
        return '#4caf50';
      } else {
        return 'primary';
      }
    },
    async getReportByHandlePlatform(handle, platform) {
      // get from social data by platform
      this.$emit('showLoadingEvent', true)
      let result = null
      if (platform === 'instagram') {
        result = await influencerAPIs.getAudienceData(handle)
      } else if (platform === 'tiktok') {
        result = await influencerAPIs.getTikTokAudienceData(handle)
      } else if (platform === 'youtube') {
        result = await influencerAPIs.getYoutubeAudienceData(handle)
      }
      this.$emit('showLoadingEvent', false)
      if (result.error) {
        return this.$swal({
          title: 'Opps!',
          text: result.error.error.message,
          type: 'info'
        });
      } else {
        this.formatAudience(result);
        this.resetChart();
        this.influencer = result;
      }
    }
  }
};
</script>
<style>
.card {
  border: none;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 00 2px 20px 0 rgba(66, 110, 184, 0.16);
}
.card-title {
  font-size: 20px;
  font-weight: 500;
}
.emoji {
  height: 26px;
  margin-right: 5px;
}
ul > li {
  list-style: none;
}
/* show stat history */
.stat-label--desc {
  color: #ff595e;
}
.stat-label--asc {
  color: #5bca65;
}
.stat-label--asc,
.stat-label--desc {
  display: inline-block;
  position: relative;
}
.stat-label {
  position: relative;
  display: inline-block;
  box-sizing: border-box;
  height: 24px;
  line-height: 24px;
  vertical-align: baseline;
  font-size: 16px;
  padding-left: 14px;
  padding-right: 4px;
}

.stat-label--asc:before,
.stat-label--desc:before {
  content: '';
  box-sizing: border-box;
  margin: 0;
  display: inline-block;
  border: 5px solid transparent;
  border-top: 6px solid;
  border-bottom: 0;
  position: absolute;
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.stat-label--asc:before {
  border: 5px solid transparent;
  border-bottom: 6px solid;
  top: calc(50% - 4px);
}
text {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  color: #898e94;
}
.aud-location-table.no-border .v-data-table__wrapper th {
  font-size: 16px;
  border: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
  padding-left: 0;
}
/* .card:hover {
    box-shadow: 00 2px 20px 0 rgba(66,110,184,.16)
  } */
</style>



// WEBPACK FOOTER //
// AudienceDataReportModal.vue?03e7bb94